import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createAsset,
  deleteAsset,
  listAssets,
  updateAsset,
  type AssetFields,
} from "@/lib/api/assets";

const assetKeys = { list: (workspaceId: string) => ["assets", workspaceId] as const };

export function useAssets(workspaceId: string | undefined) {
  return useQuery({
    queryKey: assetKeys.list(workspaceId ?? ""),
    queryFn: () => listAssets(workspaceId!),
    enabled: Boolean(workspaceId),
  });
}

function useInvalidateAssets() {
  const queryClient = useQueryClient();
  return () => void queryClient.invalidateQueries({ queryKey: ["assets"] });
}

export function useSaveAsset(workspaceId: string) {
  const invalidate = useInvalidateAssets();
  return useMutation({
    mutationFn: ({ id, fields }: { id?: string; fields: AssetFields }) =>
      id ? updateAsset(id, fields) : createAsset(workspaceId, fields),
    onSuccess: invalidate,
  });
}

export function useDeleteAsset() {
  const invalidate = useInvalidateAssets();
  return useMutation({ mutationFn: deleteAsset, onSuccess: invalidate });
}
